import { RouteConfig } from 'vue-router';
const StudyFolder = () => import('./views/study-folder.vue');
const StudyTextbook = () => import('./views/study-textbook.vue');
const StudyShe = () => import('./views/study-she.vue');
const StudyMian = () => import('./views/study-mian.vue');
const StudyMai = () => import('./views/study-mai.vue');
const StudyDetail = () => import('./views/study-detail.vue');
const ShixunQa = () => import('./views/shixun-qa.vue');
const PracticeFolder = () => import('./views/practice-folder.vue');
const PracticeDanxiang = () => import('./views/practice-danxiang.vue');
const PracticeZonghe = () => import('./views/practice-zonghe.vue');
const PracticeZicai = () => import('./views/practice-zicai.vue');
const PracticeReport = () => import('./views/practice-report.vue');
const ExamFolder = () => import('./views/exam-folder.vue');
const ExamList = () => import('./views/exam-list.vue');
const ExamReport = () => import('./views/exam-report.vue');
const ExamStart = () => import('./views/exam-start.vue');
const ExamCondition = () => import('./views/exam-condition.vue');
const routers: RouteConfig[] = [
    {
        path: 'study-folder',
        component: StudyFolder,
    },
    {
        path: 'study-textbook',
        component: StudyTextbook,
    },
    {
        path: 'study-she',
        component: StudyShe,
    },
    {
        path: 'study-mian',
        component: StudyMian,
    },
    {
        path: 'study-mai',
        component: StudyMai,
    },
    {
        path: 'study-detail',
        component: StudyDetail,
    },
    {
        path: 'shixun-qa',
        component: ShixunQa,
    },
    {
        path: 'practice-folder',
        component: PracticeFolder,
    },
    {
        path: 'practice-danxiang',
        component: PracticeDanxiang,
    },
    {
        path: 'practice-zonghe',
        component: PracticeZonghe,
    },
    {
        path: 'practice-zicai',
        component: PracticeZicai,
    },
    {
        path: 'practice-report',
        component: PracticeReport,
    },
    {
        path: 'exam-folder',
        component: ExamFolder,
    },
    {
        path: 'exam-list',
        component: ExamList,
    },
    {
        path: 'exam-report',
        component: ExamReport,
    },
    {
        path: 'exam-start',
        component: ExamStart,
    },
    {
        path: 'exam-condition',
        component: ExamCondition,
    },
];
export default routers;
